import { IconName, getIconSVG } from "./IconSVG.js";

export enum RoundIconTheme {

    dark = "dark",
    brand = "brand"

}


export interface RoundIconProps {

    theme: RoundIconTheme,
    name: IconName,

}


export class RoundIcon {

    protected mainHtml: HTMLElement;
    protected currentSvg: HTMLElement;
    constructor(protected props: RoundIconProps, protected globalCssPrefix: string) {
        this.currentSvg = getIconSVG(props.name);
        this.initHTML();
    }

    get bClass() : string {
        return `${this.globalCssPrefix}-round-icon`
    }
    private initHTML() {
        this.mainHtml = <div class={`${this.bClass} ${this.bClass}--${this.props.name} ${this.bClass}--${this.props.theme}`}>
                    {this.currentSvg}
               </div>
    }

    get html() {
        return this.mainHtml;
    }
}

export class RoundIconButton extends RoundIcon {

    constructor(protected props: RoundIconProps, protected globalCssPrefix) {
        super(props, globalCssPrefix);
    }

    get bClass() : string {
        return `${this.globalCssPrefix}-round-icon__btn`
    }
    changeIcon(icon: IconName) {
        this.currentSvg.remove();
        const newSvg = getIconSVG(icon)
        this.mainHtml.appendChild(newSvg);
        this.currentSvg = newSvg;
    }

    onClick(listener: EventListener): void {
        this.html.addEventListener("click", listener);
    }
    
    updateStatus(enabled: boolean) {
        if (enabled) {
            this.html.classList.remove('disabled')
        } else {
            this.html.classList.add('disabled');
        }
    }
}